import {Error, FloatingLabel, Label} from '@progress/kendo-react-labels';
import {TextAreaProps, InputHandle, TextArea, TextAreaBlurEvent, TextAreaHandle} from "@progress/kendo-react-inputs";
import React, {KeyboardEventHandler, useEffect, useRef, useState} from "react";
import "./FlintTextBox.scss";
import {GUID} from "../../utils/AppConstants";
import {Editor, EditorProps, EditorTools} from "@progress/kendo-react-editor";
import FlintLabel from "./FlintLabel";
import FlintTextArea from "./FlintTextArea";


export default function FlintEditor(props: FlintEditorProps) {
    const [visited, setVisited] = useState(false);
    const inputRef = useRef<TextAreaHandle | null>(null); // Corrected type for Kendo Input ref
    const {label, validationData, contentStyle = {height: 180}, defaultEditMode = "div", ...others} = props;
    // const handleBlur = (event: TextAreaBlurEvent) => {
    //     setVisited(true);
    //     validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {
    //     });
    //     if (props.onBlur) {
    //         props.onBlur(event); // Call the parent's onBlur handler if provided
    //     }
    // };
    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,
        FontName,
        FormatBlock,
        Link,
        Unlink,
        InsertImage,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell
    } = EditorTools;
    const tools = props.useSimpleToolbox ?
        [[Bold, Italic, Underline],
            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
            [Indent, Outdent],
            [OrderedList, UnorderedList],
            FontSize,
            [Link, Unlink]]
        :
        [[Bold, Italic, Underline, Strikethrough],
            [Subscript, Superscript],
            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
            [Indent, Outdent],
            [OrderedList, UnorderedList],
            FontSize,
            FontName,
            FormatBlock,
            [Undo, Redo],
            [Link, Unlink, InsertImage, ViewHtml],
            [InsertTable],
            [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
            [DeleteRow, DeleteColumn, DeleteTable],
            [MergeCells, SplitCell]];
    return (
        <>
            {props.disabled &&
                <div className="k-editor-content" style={{minHeight: "180px", border:"1px solid #e5e4e4"}}>
                    <div role="textbox" translate="no"
                         className="ProseMirror ProseMirror-focused"
                         dangerouslySetInnerHTML={{__html: props.value?.toString() ?? ""}}>
                    </div>
                </div>
            }
            {!props.disabled &&
                <div className="flint-field flint-text-area">
                    {props.label != null && <FlintLabel className={"title-label"}>{props.label}</FlintLabel>}
                    <Editor contentStyle={contentStyle}
                            defaultEditMode={defaultEditMode}
                            tools={tools}
                            {...others}
                    />
                    {validationData?.validationMessage != null && <Error>{validationData?.validationMessage}</Error>}
                </div>}
        </>
    );
}

export interface FlintEditorProps extends EditorProps {
    label?: string;
    disabled?: boolean;
    useSimpleToolbox?: boolean;
    validationData?: {
        validationMessage?: string | undefined,
        validateFunction?: (objectToValidate?: any) => Promise<void>,
        optionalObjectToValidate?: any
    }
}
